module.exports = __webpack_public_path__ + "img/true--icon.a9f8612e.svg";